import type { UserData } from "@/types/users";

export const useApiUser = () => {
    return useState<UserData | null>('user', () => null);
}